export default "__VITE_PUBLIC_ASSET__33ebfe88__"